export class ChartDataModel {
    constructor(id: string, name: string, amount: number, fill: string, handleOnClick?: () => void, parentChartName?: string, parentChartFill?: string, subName?: string) {
        this.id = id;
        this.name = name;
        this.subName = subName;
        this.amount = amount;
        this.fill = fill;
        this.parentChartName = parentChartName;
        this.parentChartFill = parentChartFill;
        this.handleOnClick = handleOnClick
    }
    id: string;
    name: string;
    subName?: string;
    amount: number;
    fill: string;
    parentChartName?: string;
    parentChartFill?: string;
    handleOnClick?: () => void;
}

export class ChartModel {
    name: string;
    elements: ChartDataModel[];
}
